import { useCallback, useEffect, useRef, useState } from 'react'
import GameOverScreen from '../components/game-over-screen'
import { submitScore } from '../utils/api'
import { initGamearea, resetGame } from './game'

const GameArea = props => {
    const gameArea = useRef()
    const gameScore = useRef()
    const gameInstructions = useRef()
    const ran = useRef(false)
    const [ isGameOver, setIsGameOver ] = useState( false )
    const [ score, setScore ] = useState( 0 )

    const onGameOver = useCallback( (score) => {
        setScore( score )
        setIsGameOver( true )

        // Required for the game.
        if ( props.onGameOver ) {
            props.onGameOver( score )
        }
        // Required for the game.
        const f = async () => {
            await submitScore( 'FLAPPY_BLOCK', props.email, score, props.nick )
        }
        f()
    }, [ props.nick, props.email, props.onGameOver, score ] ) // eslint-disable-line

    useEffect( () => {
        if ( ! ran.current ) {
            // Specific to flappy block.
            const i = setInterval( () => {
                if ( gameArea.current.clientWidth !== 0 ) {
                    initGamearea( gameArea.current, gameScore.current, gameInstructions.current, onGameOver )
                    clearInterval( i )
                }
            }, 500 )
            ran.current = true
        }
    }, [] ) // eslint-disable-line

    const onRestart = () => {
        setIsGameOver( false )
        resetGame()
    }

    return (
      <div className="game-area" ref={ gameArea }>
        { isGameOver && (
            <GameOverScreen 
                { ...props } // Required for the scores and ranking
                onRestart={ onRestart } 
                score={ score } 
            /> 
        ) }
        <div className="game-score" ref={ gameScore } />
        <div className="game-instructions" ref={ gameInstructions }>Click to Fly!</div>
      </div>
    )
}

export default GameArea